import { call, put, takeLatest } from "redux-saga/effects";
import { ufTrangThaiKhoApi } from "../../../api/quan-ly-kho/trangThaiKhoApi";
import { ITrangThaiKhoSearchRequest } from "../../../model/request/quan-ly-kho/ITrangThaiKhoSearchRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eTrangThaiKhoActionTypeIds, ITrangThaiKhoActions } from "../../action-types/quan-ly-kho/ITrangThaiKhoActionTypes";
import { rootActions } from "../../actions/rootActions";

const mainAction = rootActions.quanLyKho.trangThaiKho;

export function* trangThaiKhoSaga(): any {
    yield takeLatest(eTrangThaiKhoActionTypeIds.LOAD_START, loadWorker)
}

function* loadWorker(action: ITrangThaiKhoActions): any {
    const searchRequest = action.payload as ITrangThaiKhoSearchRequest;
    const res: IBaseRespone = yield call(ufTrangThaiKhoApi.Select, searchRequest);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}
